export default __webpack_public_path__ + "61da0fff04b54399baaea53fb25b37a9.svg";